'use client'

import { useMemo, useState } from 'react'
import type { ReactNode } from 'react'
import { useLogout } from '../../../hooks/useLogout'
import { SidebarProvider, useSidebar } from '../../../contexts/SidebarContext'

import Sidebar from './Sidebar';
import Header from './Header';
import MainContent from './MainContent';
import { useLocation } from 'react-router-dom';
import { cedarModules } from '../../../modules';
import type { CedarModuleConfig } from '../../../modules';
import type { NavigationItem } from '../../../navigation/types';
import { useCanAccessExplorerLab } from '../../../modules/data/access';

const AppShellContent = (props: { children?: ReactNode }) => {
  const [, setSidebarOpen] = useState(false);
  const { sidebarState, setSidebarState } = useSidebar();
  const logout = useLogout();
  const location = useLocation();
  const canAccessExplorerLab = useCanAccessExplorerLab();

  const routes = useMemo<CedarModuleConfig['routes']>(() => {
    const segment = location.pathname.split('/')[1] || '';
    const match = cedarModules.find((t) => t.key === segment);
    const nextRoutes = match?.routes || [];

    if (segment !== 'data' || canAccessExplorerLab) {
      return nextRoutes;
    }

    return nextRoutes.filter((route) => route.href !== '/data/explorer-lab');
  }, [canAccessExplorerLab, location.pathname]);

  const handleToggle = () => {
    setSidebarState(sidebarState === 'expanded' ? 'collapsed' : 'expanded');
  };

  return (
    <>
      <div className="flex min-h-screen">
        {sidebarState !== 'invisible' && (
          <Sidebar navigation={(routes || []) as NavigationItem[]} collapsed={sidebarState === 'collapsed'} onToggle={handleToggle} />
        )}
        <div className="flex-1 min-w-0 bg-gray-50 h-full overflow-y-auto">
          <Header setSidebarOpen={setSidebarOpen} logout={logout} navigation={routes} />
          <MainContent>{props.children}</MainContent>
        </div>
      </div>
    </>
  );
};

export const AppShell = (props: { children?: ReactNode }) => {
  return (
    <SidebarProvider>
      <AppShellContent {...props} />
    </SidebarProvider>
  );
};

export default AppShell;